import api from '@/api/tickets';

const initCreateForm = {
    title: null,
    category_id: null,
    ticket_message: null,
    order_id: null
}

const initAddMessageForm = {
    message: null,
    ticket_id: null,
}

export default {
    state: {
        tickets: null,
        ticketCategories: null,
        ticket: null,
        formCreate: {
            ...initCreateForm
        },
        forms: {
            create: {
                ...initCreateForm
            },
            addMessage: {
                ...initAddMessageForm
            }
        }
    },
    getters: {
        getTicketCategories(state) {
            const {
                ticketCategories
            } = state;

            if (!ticketCategories) return [];

            return Object.entries(ticketCategories).map(([id, text]) => {
                return {
                    id: +id,
                    text
                }
            })
        }
    },
    mutations: {
        SET_TICKETS_DATA(state, payload) {
            state.tickets = payload;
        },
        SET_TICKET_CATEGORIES_DATA(state, payload) {
            state.ticketCategories = payload;
        },
        SET_TICKET_DATA(state, payload) {
            state.ticket = payload;
        },
        RESET_TICKET_DATA(state) {
            state.ticket = null;
        },
        UPDATE_CREATE_TICKET_FORM(state, payload) {
            const {
                key,
                value
            } = payload;

            const {
                forms
            } = state;

            state.forms = {
                ...forms,
                create: {
                    ...forms.create,
                    [key]: value
                }
            };
        },
        UPDATE_ADD_MESSAGE_FORM(state, payload) {
            const {
                key,
                value
            } = payload;

            const {
                forms
            } = state;

            state.forms = {
                ...forms,
                addMessage: {
                    ...forms.addMessage,
                    [key]: value
                }
            };
        },
        RESET_CREATE_TICKET_FORM(state) {
            state.forms.create = initCreateForm;
        },
        RESET_ADD_MESSAGE_FORM(state) {
            const {
                forms
            } = state;

            state.forms = {
                ...forms,
                addMessage: initAddMessageForm
            }
        },
        RESET_ADD_MESSAGE_FIELD(state, payload) {
            const {
                forms
            } = state;

            state.forms = {
                ...forms,
                addMessage: {
                    ...forms.addMessage,
                    [payload]: null
                }
            }
        },
    },
    actions: {
        fetchTickets({
            commit,
            dispatch,
        }) {
            dispatch('setIsLoadingData', true);
            api.get().then(({
                data: {
                    data: {
                        tickets
                    }
                }
            }) => {
                commit('SET_TICKETS_DATA', tickets);
            }).finally(() => {
                dispatch('setIsLoadingData', false);
            });
        },
        async fetchTicketById({
            commit,
            dispatch,
        }, payload) {
            dispatch('setIsLoadingData', true);
            try {
                const result = await api.getById(payload);
                commit('SET_TICKET_DATA', result.data.data);
                return Promise.resolve(result.data);
            } catch (e) {
                const {
                    response: {
                        data: {
                            data: {
                                messages
                            }
                        }
                    }
                } = e;

                return Promise.reject(messages);
            } finally {
                dispatch('setIsLoadingData', false);
            }
        },
        fetchTicketCategories({
            commit,
            dispatch,
        }) {
            dispatch('setIsLoadingData', true);
            api.getCategories().then(({
                data: {
                    data: {
                        categories
                    }
                }
            }) => {
                commit('SET_TICKET_CATEGORIES_DATA', categories);
            }).finally(() => {
                dispatch('setIsLoadingData', false);
            });
        },
        async saveTicket({
            state,
            dispatch,
        }) {
            dispatch('setIsLoadingData', true);
            const {
                create
            } = state.forms;

            try {
                const result = await api.save(create);
                return Promise.resolve(result);
            } catch (e) {
                const {
                    response: {
                        data: {
                            data: {
                                errors
                            }
                        }
                    }
                } = e;

                return Promise.reject(errors);
            } finally {
                dispatch('setIsLoadingData', false);
            }
        },
        async addMessage({
            state,
            dispatch,
        }) {
            dispatch('setIsLoadingData', true);
            const {
                addMessage
            } = state.forms;

            try {
                const result = await api.addMessage(addMessage);
                return Promise.resolve(result);
            } catch (e) {
                const {
                    response: {
                        data: {
                            data: {
                                errors
                            }
                        }
                    }
                } = e;

                return Promise.reject(errors);
            } finally {
                dispatch('setIsLoadingData', false);
            }
        },
        async setTicketStatus({
            dispatch,
        }, payload) {
            dispatch('setIsLoadingData', true);
            try {
                const result = await api.setStatus(payload);
                return Promise.resolve(result.data.data);
            } catch (e) {
                const {
                    response: {
                        data: {
                            data: {
                                errors
                            }
                        }
                    }
                } = e;

                return Promise.reject(errors);
            } finally {
                dispatch('setIsLoadingData', false);
            }
        },
    },
};